// src/pages/Purchase/Purchase Entry/purchaseThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { postData } from "../../../../apiservice/apis";
import { getPurchaseVoucherNumberApi } from "../../../../apiservice/purchase";
import { createPurchaseEntryPayload } from "../../../../utils/purchaseEntry"; // ✅ use new payload creator
import { pathSpliter } from "../../../../lib/functions";
import {
  getAccountBySeachApi,
  getAccountByTypeApi
} from "../../../../apiservice/setting";
import { getPendingPurchaseOrderApi } from "../../../../apiservice/accounts";

// 🔹 Fetch purchase voucher number
export const fetchPurchaseEntryNumber = createAsyncThunk(
  "purchaseEntry/fetchPurchaseVoucherNumber",
  async (val) => {
    const res = await getPurchaseVoucherNumberApi({ entryDate: val });
    return res.data;
  }
);

// 🔹 Fetch purchase accounts
export const fetchPurchaseAccs = createAsyncThunk(
  "purchaseEntry/fetchPurchaseAccs",
  async () => {
    const res = await getAccountBySeachApi({
      multiType: ["purchase_account"],
    });
    return res.data;
  }
);

// 🔹 Fetch Fixed Asset accounts — for the Asset Account picker, scoped to
// fixed_asset-type accounts only (mirrors the Service Account picker's scope
// to service_account-type accounts on Sales Invoices).
export const fetchAssetAccs = createAsyncThunk(
  "purchaseEntry/fetchAssetAccs",
  async () => {
    const res = await getAccountBySeachApi({
      multiType: ["fixed_asset"],
    });
    return res.data;
  }
);

// 🔹 Fetch a single purchase record with details
// export const fetchPurchaseRecord = createAsyncThunk(
//   "purchaseEntry/fetchPurchaseRecord",
//   async (location, { rejectWithValue }) => {

//     try {
//       let url = `/purchase/get-purchase-record-with-details`;
//       let para = {
//         pur_id:
//           pathSpliter(location.location?.pathname, 3) !== undefined
//             ? parseFloat(pathSpliter(location.location?.pathname, 3))
//             : 0,
//       };

//       if (pathSpliter(location.location?.pathname, 2) === "order-to-purchase") {
//         url = `/purchase/get-purchase-order-record-with-details`;
//         para = {
//           pur_o_id:
//             pathSpliter(location.location?.pathname, 3) !== undefined
//               ? parseFloat(pathSpliter(location.location?.pathname, 3))
//               : 0,
//         };
//       }

//       const res = await postData(url, para);
//       const data = res.data[0];
//       if (!data) return null;

//       const dataDetails = data.details || [];
//       let trans = [];

//       if (pathSpliter(location.location?.pathname, 2) !== "order-to-purchase") {
//         trans = data.trans || [];
//       }

//       // map items like old UI
//       const itemCart = dataDetails.map((item) => {
//         let serials = [];
//         if (item.is_serial === "yes" && item.serials) {
//           serials = item.serials.split(",").map((slNo) => ({
//             serial_number: slNo,
//           }));
//         }

//         return {
//           ...item,
//           serials,
//           qty_display:
//             item.item_qty +
//             " " +
//             item.unit_symbol +
//             (item.conversion > 1
//               ? ", " + item.retail_qty + " " + item.base_unit_name
//               : ""),
//         };
//       });

//       return {
//         record: data,
//         itemCart,
//         trans,
//       };
//     } catch (err) {
//       return rejectWithValue(err.response?.data || err.message);
//     }
//   }
// );

// export const fetchPurchaseRecord = createAsyncThunk(
//   "purchaseEntry/fetchPurchaseRecord",
//   async (location, { rejectWithValue }) => {
//     try {
//       let url = `/purchase/get-purchase-record-with-details`;
//       let para = {
//         pur_id:
//           pathSpliter(location.location?.pathname, 3) !== undefined
//             ? parseFloat(pathSpliter(location.location?.pathname, 3))
//             : 0,
//       };

//       let isPO = false;
//       if (pathSpliter(location.location?.pathname, 2) === "order-to-purchase") {
//         url = `/purchase/get-purchase-order-record-with-details`;
//         para = {
//           pur_o_id:
//             pathSpliter(location.location?.pathname, 3) !== undefined
//               ? parseFloat(pathSpliter(location.location?.pathname, 3))
//               : 0,
//         };
//         isPO = true;
//       }

//       const res = await postData(url, para);
//       const data = res.data[0];
//       if (!data) return null;

//       const dataDetails = data.details || [];
//       let trans = [];

//       // ✅ Map PO or Purchase items into itemCart
//       const itemCart = dataDetails.map((item) => {
//         let serials = [];
//         if (item.is_serial === "yes" && item.serials) {
//           serials = item.serials.split(",").map((slNo) => ({
//             serial_number: slNo,
//           }));
//         }
//         return {
//           ...item,
//           serials,
//           qty_display:
//             item.item_qty +
//             " " +
//             item.unit_symbol +
//             (item.conversion > 1
//               ? ", " + item.retail_qty + " " + item.base_unit_name
//               : ""),
//           key: item.pur_d_id || Date.now(), // unique row key
//           item_id: item.item_id,
//           product: item.item_name,
//           quantity: Number(item.remaining_item_qty) || 0,
//           rate: Number(item.item_rate) || 0,
//           tax_per: Number(item.item_tax_per) || 0,
//           discount: Number(item.item_discount_per) || 0,
//           bonus: false,
//           batch_name: "",
//           batch_id: 0,
//           batch_expiry: null,
//           is_expiry_disable: false,
//           unit_id: item.unit_id,
//           unit_name: item.unit_name,
//           unit_symbol: item.unit_symbol,
//           units: item.units || [],
//         };
//       });

//       return {
//         record: data,
//         itemCart,
//         trans,
//         isPO, // mark if it’s from PO
//       };
//     } catch (err) {
//       return rejectWithValue(err.response?.data || err.message);
//     }
//   }
// );

export const fetchPurchaseRecord = createAsyncThunk(
  "purchaseEntry/fetchPurchaseRecord",
  async ({ pur_o_id = null, pur_id = null }, { rejectWithValue }) => {
    try {
      let url = `/purchase/get-purchase-record-with-details`;
      let para = {};
      let isPO = false;

      if (pur_o_id) {
        url = `/purchase/get-purchase-order-record-with-details`;
        para = { pur_o_id };
        isPO = true;
      } else if (pur_id) {
        para = { pur_id };
      } else {
        return null;
      }

      const res = await postData(url, para);
      const po = res.data[0];
      if (!po) return null;

      const taxMode = po.is_cal_type || "individual";
      const details = po.details || [];

      const itemCart = details.map((it) => {
        // 🔥 IMPORTANT:
        // If converting from PO → use remaining_item_qty
        // If editing purchase → use item_qty
        const qty = isPO
          ? Number(it.remaining_item_qty) || 0
          : Number(it.item_qty) || 0;

        if (isPO && qty <= 0) return null;

        const rate = Number(it.item_rate) || 0;

        const discountPct =
          taxMode === "individual"
            ? Number(it.item_discount_per || it.discount_per || it.discount || 0)
            : 0;

        const taxPer =
          taxMode === "individual" ? Number(it.item_tax_per) : 0;

        // calculate line total for UI
        let line = qty * rate;

        if (taxMode === "individual") {
          const discountAmt = (discountPct / 100) * line;
          const afterDiscount = line - discountAmt;
          const taxAmt = (taxPer / 100) * afterDiscount;
          line = afterDiscount + taxAmt;
        }

        return {
          key: it.pur_d_id || Date.now(),
          item_id: it.item_id,
          product: it.item_name,
          quantity: qty,
          rate,
          discount: discountPct,
          tax_per: taxPer,
          bonus: false,

          unit_id: it.unit_id,
          unit_name: it.unit_name,
          unit_symbol: it.unit_symbol,
          units: it.units || [],

          batch_name: "",
          batch_id: 0,
          batch_expiry: null,
          is_expiry_disable: false,

          line_total: Number(line).toFixed(2),
        };
      })
        .filter(Boolean); // 🚀 remove null rows


      const itemIds = itemCart.map(i => i.item_id).filter(Boolean);

      // Prevent full conversion
      if (isPO && itemCart.length === 0) {
        return rejectWithValue("This Purchase Order is fully converted.");
      }


      let subtotal = 0;
      let totalDiscount = 0;
      let totalTax = 0;

      if (taxMode === "individual") {
        itemCart.forEach((it) => {
          const qty = Number(it.quantity);
          const rate = Number(it.rate);

          const line = qty * rate;

          const discountAmt = (it.discount / 100) * line;
          const afterDiscount = line - discountAmt;

          const taxAmt = (it.tax_per / 100) * afterDiscount;

          subtotal += line;
          totalDiscount += discountAmt;
          totalTax += taxAmt;
        });
      } else {
        // on_total: trust PO values
        subtotal = Number(po.sub_total);
        totalDiscount = Number(po.total_discount);
        totalTax = Number(po.total_tax);
      }

      const otherCost = Number(po.other_service_cost || 0);
      const transportCharge = Number(po.total_transport_cost || 0);

      const grandTotal =
        taxMode === "on_total"
          ? Number(po.total_amount)
          : subtotal - totalDiscount + totalTax + transportCharge + otherCost;


      const footerValues = {
        subtotal: subtotal.toFixed(2),
        total_discount: totalDiscount.toFixed(2),
        totalTax: totalTax.toFixed(2),
        transportCharge,
        other_service_cost: otherCost,
        grandTotal: grandTotal.toFixed(2),
        paidAmount: 0,
        dueAmount: grandTotal.toFixed(2),
      };

      if (taxMode === "on_total") {
        footerValues.discountPct = Number(po.total_discount_per || 0);
      }

      const supplierInfo = {
        acc_id: po.acc_id,
        acc_name: po.acc_name,
        institution_name: po.institution_name,
        address: po.address,
        contact_no: po.contact_no,
      };

      return {
        record: po,
        itemCart,
        trans: [],
        isPO,
        supplierInfo,
        footerValues,
        taxMode,
      };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);




// Fetch pending POs for a supplier
export const fetchPendingPurchaseOrders = createAsyncThunk(
  "purchaseEntry/fetchPendingPurchaseOrders",
  async (acc_id, { rejectWithValue }) => {
    try {
      const res = await getPendingPurchaseOrderApi({ acc_id });
      // add type field to differentiate PO rows in UI
      return res.data.map((order) => ({ ...order, type: "po" }));
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// 🔹 Create or Update Purchase Entry
export const createPurchaseEntry = createAsyncThunk(
  "purchaseEntry/createPurchaseEntry",
  async ({ orderId = 0 } = {}, { getState, rejectWithValue }) => {
    try {
      const state = getState().purchaseEntry;

      const stateAuth = getState();
      const authInfo = stateAuth.auth.auth_info;


      const payload = createPurchaseEntryPayload(state, authInfo);

      // ✅ Use directly passed orderId — no state dependency
      payload.orderId = orderId || state.pur_o_id || 0;

      const body = state.purchase_id
        ? { ...payload, purchase_id: state.purchase_id }
        : payload;

      let dataToSend = body;
      if (state.invoiceFile instanceof File) {
        const formData = new FormData();
        formData.append("data", JSON.stringify(body));
        formData.append("invoice_file", state.invoiceFile);
        dataToSend = formData;
      }

      let res;
      if (state.purchase_id) {
        res = await postData(`/purchase/update-purchase`, dataToSend);
      } else {
        res = await postData(`/purchase/create-purchase`, dataToSend);
      }

      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchGetAccountByTypeApi = createAsyncThunk(
  "purchaseEntry/getAccountByTypeApi",
  async (acc_id, { rejectWithValue }) => {
    try {
      const res = await getAccountByTypeApi({ acc_type_id: "direct_expense" });
      // add type field to differentiate PO rows in UI
      return res.data[2];
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
